import { generateHashFromVariables } from '../../../utils/caching/common/key-generator';
import { inMemoryCache } from '../../../utils/caching/in-memory';
import { type TeamsBulkRequest, type TeamsBulkResponse } from './types';

const TEAMS_BULK_REST_API_URL = '/gateway/api/v4/teams/withMembers/bulk';

const cache = inMemoryCache<any>();

export const generateCacheKey = (request: TeamsBulkRequest): string => {
	const keyObj = {
		teamIds: request.teamIds.sort(),
	};

	return generateHashFromVariables(keyObj);
};

export const fetchTeamsBulk = async (request: TeamsBulkRequest): Promise<TeamsBulkResponse> => {
	return cache.inMemoryDecorator(generateCacheKey(request), () =>
		fetch(TEAMS_BULK_REST_API_URL, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'content-type': 'application/json',
			},
			body: JSON.stringify(request),
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}

				return Promise.reject({
					teams: [],
					failures: [
						{
							teamIds: request.teamIds,
							description: `Unable to fetch ${TEAMS_BULK_REST_API_URL} ${response.statusText}`,
							typeId: 'FETCH_ERROR',
						},
					],
				});
			})
			.catch((e) => {
				return {
					teams: [],
					failures: [{ teamIds: request.teamIds, description: e.message, typeId: 'FETCH_ERROR' }],
				};
			}),
	);
};
